module.exports = __webpack_public_path__ + "static/img/button_setup@2x.b3257da6.png";